export default __webpack_public_path__ + "static/media/1.2d23fd37.jpg";